import { ICustomer, ICustomerContact, ISupplier, ISupplierContact } from '../graphql/schema/p4types';

export const getPrimaryContact = (
  customerOrSupplier: ICustomer | ISupplier
): Maybe<ICustomerContact | ISupplierContact> => {
  const value = customerOrSupplier.contacts;
  if (value && Array.isArray(value)) {
    return value.find((val) => val.primaryContact) || ({} as ICustomerContact | ISupplierContact);
  }
  return {} as ICustomerContact | ISupplierContact;
};
